<template>
  <v-card class="card-wrap">
    <v-container style="padding: 12px 24px 0 24px;">
      <v-layout row wrap class="mt-2 rows">
        <v-flex xs3>
          <span>氏名</span>
        </v-flex>
        <v-flex xs7>
          <span v-show="!editNameMode"> {{ account.name }} </span>
          <TextFieldInline
            ref="nameTextField"
            v-show="editNameMode"
            v-model="inputText"
            label="氏名"
          />
        </v-flex>
        <v-flex xs2>
          <v-icon
            v-show="!editNameMode && !editEmailMode"
            @click="changeEditNameMode"
            class="inline-edit-button"
          >
            edit
          </v-icon>
          <v-btn
            v-show="editNameMode"
            :loading="loading"
            @click="save"
            outline
            color="primary"
            class="inline-save-button"
          >
            保存
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="mt-2 rows">
        <v-flex xs3>
          <span>E-mail</span>
        </v-flex>
        <v-flex xs7>
          <span v-show="!editEmailMode"> {{ account.email }} </span>
          <TextFieldInline
            ref="emailTextField"
            v-show="editEmailMode"
            v-model="inputText"
          />
        </v-flex>
        <v-spacer />
        <!--
        <v-flex xs2>
          <v-icon
            v-show="!editNameMode && !editEmailMode"
            class="inline-edit-button"
            @click="changeEditEmailMode"
          >
            edit
          </v-icon>
          <v-btn
            v-show="editEmailMode"
            :loading="loading"
            outline
            color="primary"
            class="inline-save-button"
            @click="save"
          >
            保存
          </v-btn>
        </v-flex>
        -->
      </v-layout>
      <v-layout row wrap class="mt-2 rows">
        <v-flex xs3>
          <span>アカウント種別</span>
        </v-flex>
        <v-flex xs9>
          <span> {{ displayUserType }} </span>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="mt-2 rows">
        <v-flex xs3>
          <span>所属</span>
        </v-flex>
        <v-flex xs9>
          <span> {{ account.belongName }} </span>
        </v-flex>
      </v-layout>
      <v-layout
        align-center
        justify-end
        row
        fill-height
        style="min-height: 40px;"
      >
        <v-btn
          v-show="!editNameMode && !editEmailMode"
          @click="changePassword"
          small
          outline
          color="primary"
        >
          パスワード変更
        </v-btn>
      </v-layout>
      <ChangePassword v-if="showPasswordModal" v-model="showPasswordModal" />
    </v-container>
    <v-card-actions>
      <v-layout align-center justify-space-around>
        <template v-if="editNameMode || editEmailMode">
          <v-btn :loading="loading" @click="reset" outline color="red">
            キャンセル
          </v-btn>
        </template>
        <template v-else>
          <v-btn :loading="loading" @click="logout" outline color="red">
            ログアウト
          </v-btn>
          <v-btn :loading="loading" @click="closeCard" outline color="primary">
            閉じる
          </v-btn>
        </template>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import { actions, snackbarType } from '@/vuex/modules/ui/snackbar/constants'
import TextFieldInline from '@/components/Shared/CrudUI/TextFieldInline'
import ChangePassword from '@/components/Shared/ToolBar/EditOwnAccount/ChangePassword'
import JAPANESE from '@/constants/japanese'

// todo model化
import Account from '@/api/account'

export default {
  components: {
    ChangePassword,
    TextFieldInline,
  },
  data() {
    return {
      loading: false,
      showPasswordModal: false,
      inputText: '',
      editNameMode: false,
      editEmailMode: false,
    }
  },
  computed: {
    ...mapState('account', {
      account: state => state.account,
    }),
    displayUserType() {
      return JAPANESE.userType[this.account.userType]
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('loginAuth/LOGOUT')
    },
    changeEditNameMode() {
      this.inputText = this.account.name
      this.editNameMode = true
      this.$nextTick(() => this.$refs.nameTextField.focus())
    },
    changeEditEmailMode() {
      this.inputText = this.account.email
      this.editEmailMode = true
      this.$nextTick(() => this.$refs.emailTextField.focus())
    },
    reset() {
      this.editNameMode = false
      this.editEmailMode = false
    },
    closeCard() {
      this.reset()
      this.$emit('close')
    },
    changePassword() {
      this.showPasswordModal = true
    },
    async save() {
      this.loading = true
      try {
        /*
          当面は自分のemailを変更できない仕様に決まったので
          const requestBody = this.editNameMode
            ? { name: this.inputText }
            : { email: this.inputText }
        */
        // userTypeやstatusもAPIが要求している
        const requestBody = {
          name: this.inputText,
          userType: this.account.userType,
          email: this.account.email,
          status: this.account.status,
        }
        await Account.putAccount(this.account.id, requestBody)
        await this.$store.dispatch(actions.SHOW_SNACKBAR, {
          type: snackbarType.SUCCESS,
          message: '保存完了しました',
        })
      } catch (e) {
        const error = new Error('保存に失敗しました。')
        this.loading = false
        throw error
      }
      this.editNameMode
        ? this.$store.dispatch('account/UPDATE_NAME', this.inputText)
        : this.$store.dispatch('account/UPDATE_EMAIL', this.inputText)
      this.loading = false
      this.reset()
    },
  },
}
</script>

<style scoped>
.card-wrap {
  width: 32vw;
  min-width: 320px;
  max-width: 600px;
  height: 20vh;
  min-height: 240px;
  max-height: 480px;
}
.inline-edit-button {
  font-size: 18px;
  padding-left: 32px;
}
.inline-save-button {
  height: 18px;
  padding: 0;
  margin: 0 0 0 16px;
}
.v-btn {
  width: 40%;
  min-width: 80px;
  max-width: 240px;
}
</style>
